import React from 'react';
import styled from 'styled-components';
import SelectArrowImg from '../image/SelectArrowImg';
import $ from 'jquery';
import { useState, useRef, useEffect } from 'react';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const SelectClipProdSecondWrapFilterSelectBlock = styled.div`
    //margin: 12px 0;
    //margin-bottom:12px;
    float : left;
    
    ${isMobileOnly?`
    width : 40vw;
  `:`
    width : 235px;
  `};
`;

const SelectClipProdSecondWrapSelectBlock = styled.select`
    display: none;
`;

const SelectClipProdSecondWrapSelectOptionBlock = styled.option`

`;

const SelectClipProdSecondWrapSelectListUlBlock = styled.ul`
    margin-right: 0;
    //padding: 6px 0;
    //margin-right: 30px;
    color: #666;
    font-size: 14px;
    position: relative;
`;
const SelectClipProdSecondWrapSelectListSelectedLiBlock = styled.li`
    color: #111;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    height : 20px;
    text-align: left;
    float : left;
    ${isMobileOnly?`
    width : 40vw;
  `:`
    width : 235px;
  `};
    margin-top: 20px;
    ::after {
    content: '';
    display: inline-block;
    width: 13px;
    height: 7px;
    margin-left: 10px;
    //margin-right : 34px;
    float: right;
    margin-top: 6px;
    background: url(/assets/images/icon/ds-icon.png) center center/cover no-repeat;
    }
`;

const SelectClipProdSecondWrapSelectListLiBlock = styled.li`
    cursor: pointer;
    display : ${props => props.display};
`;

const SelectClipProdSecondWrapSelectListSubUlBlock = styled.ul`
    ${isMobileOnly?`
    width : 45vw;
    `:`
    width : 235px;
    right: 0;
    `};
    text-align: left;
    top: 60px;
    //width: max-content;
    padding-left: 15px;
    padding-right: 15px;
    background-color: #fff;
    //border: 1px solid #fcc643;
    border: 1px solid #ccc;
    border-radius: 4px;
    //display: none;
    position: absolute;
    //width: 100%;
    z-index: 1;
    display : ${props => props.display};
`;

const SelectClipProdSecondWrapSelectListSubLiBlock = styled.li`
    //margin-bottom: 10px;
    word-break: keep-all;
    cursor: pointer;
    //font-weight: ${props => props.weight};
    padding: 13px 0;
    font-size: 14px;
    font-weight: 400;
    color: #111;
    
    &:hover {
        font-weight: 700;
        text-decoration: underline;
`;

const SLIDE_DURATION = 150;

const SelectClipProd = ({ options, onChange, valueDefault }) => {
    const [displaySelectBox, setDisplaySelectBox] = useState(false);
    const selectRef = useRef(null);
    const selectContainRef = useRef(null);

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (selectContainRef.current && !selectContainRef.current.contains(event.target)) {

                if (selectRef.current && !selectRef.current.contains(event.target)) {
                    //setDisplaySelectBox(false);
                    const el = selectRef.current;
                    //$(el).slideUp(SLIDE_DURATION);
                    $(el).slideUp(SLIDE_DURATION, function () {
                        setDisplaySelectBox(false);
                    });
                }
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [selectContainRef, selectRef]);

    const handleSelectClick = () => {
        //console.log("handleSelectClick displaySelectBox="+displaySelectBox);
        if (displaySelectBox) {

            // console.log("slideUp")
            if (selectRef.current) {
                const el = selectRef.current;

                $(el).slideUp(SLIDE_DURATION, function () {
                    setDisplaySelectBox(false);
                });
            }
        }
        else {
            setDisplaySelectBox(true);
            if (selectRef.current) {
                const el = selectRef.current;
                // console.log("slideDown")
                $(el).slideDown(SLIDE_DURATION);
                //$(el).parents('li').addClass('active');
            }
        }
    }

    const getSelectedName = () => {
        if (valueDefault) {
            return valueDefault.brnd_han;
        }
        else {
            valueDefault = options[0];
            return options[0].brnd_han;
        }
    }

    const handleChangeValue = (option) => {
        if (option.brnd_id === valueDefault.brnd_id) {

        }
        else {
            if (onChange) {
                onChange(option);
            }
        }

        if (selectRef.current) {
            const el = selectRef.current;
            $(el).slideUp(SLIDE_DURATION, function () {
                setDisplaySelectBox(false);
            });
        }
    }

    return (
        <SelectClipProdSecondWrapFilterSelectBlock>

            <SelectClipProdSecondWrapSelectListUlBlock>
                <SelectClipProdSecondWrapSelectListSelectedLiBlock ref={selectContainRef} onClick={handleSelectClick}>
                    {getSelectedName()}
                </SelectClipProdSecondWrapSelectListSelectedLiBlock>
                <SelectClipProdSecondWrapSelectListLiBlock display={displaySelectBox ? "block" : "none"}>
                    <SelectClipProdSecondWrapSelectListSubUlBlock ref={selectRef} className="sz-select_sub" display={displaySelectBox ? "block" : "none"}>
                        {
                            options.map((option) => (
                                <SelectClipProdSecondWrapSelectListSubLiBlock key={option.brnd_id}
                                    onClick={() => { handleChangeValue(option) }}
                                    weight={option.brnd_id === valueDefault.brnd_id ? 700 : 400}>
                                    {option.brnd_han}
                                </SelectClipProdSecondWrapSelectListSubLiBlock>
                            ))
                        }
                    </SelectClipProdSecondWrapSelectListSubUlBlock>
                </SelectClipProdSecondWrapSelectListLiBlock>
            </SelectClipProdSecondWrapSelectListUlBlock>
        </SelectClipProdSecondWrapFilterSelectBlock>
    );
};

export default SelectClipProd;
